const _getHasSitewideDiscountOnly = (
  promotionCodes: (string | null | undefined)[] | undefined,
  showUrlDiscount: boolean,
  sitewideDiscounts: string | string[],
): boolean | undefined => {
  if (!sitewideDiscounts.length || showUrlDiscount) return false;

  if (Array.isArray(sitewideDiscounts)) {
    return sitewideDiscounts.some((sitewideDiscount) =>
      promotionCodes?.includes(sitewideDiscount),
    );
  } else {
    return promotionCodes?.includes(sitewideDiscounts);
  }
};

export default _getHasSitewideDiscountOnly;
